import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const formatDate = (date: string | Date, pattern = 'dd/MM/yyyy'): string => {
  return format(new Date(date), pattern, { locale: ptBR })
}
